import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const sixt = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "Sixt Partnerwerkstätten in Ihrer Nähe",
      hero: {
        title: "<strong>{{organization}}<br>Werkstatt-Buchung</strong>",
        subtitle: null,
      },
      layout: {
        backText: "Zurück zu sixt.de",
        navbar: {
          partnerLogo: {
            alt: "Sixt",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/sixt",
    },
  },
};
